import type { RootStore } from './RootStore';
import { action, observable, makeObservable } from 'mobx';
import { ContactModelV2 } from 'Models/ContactModelV2';
import { BaseStore } from './BaseStore';

/**
 * Filter set from outside the Call Logs page by "View call history" actions
 * (contact and conversation details panel). Stored here because
 * useCallLogsSearch might not be mounted yet when the filter is set;
 * consumed and cleared by useCallLogsSearch once applied.
 */
export type PendingCallLogsFilter =
  | { type: 'contact'; contact: ContactModelV2 }
  | { type: 'phone'; phoneNumber: string };

export class CallLogsStore extends BaseStore {
  constructor(rootStore: RootStore) {
    super(rootStore);
    makeObservable(this);
  }

  @action clearAllData = () => { };

  // Needed for Offline mode
  @observable lastSyncDate = '';
  @action setLastSyncDate = (lastSyncDate: string) =>
    (this.lastSyncDate = lastSyncDate);

  @observable searchQuery = '';
  @action
  setSearchQuery = (searchQuery: string) => (this.searchQuery = searchQuery);

  @observable pendingFilter: PendingCallLogsFilter | null = null;

  @action
  setPendingFilter = (pendingFilter: PendingCallLogsFilter) => {
    this.pendingFilter = pendingFilter;
  };

  @action
  clearPendingFilter = () => {
    this.pendingFilter = null;
  };
}
export default CallLogsStore;
